export default __webpack_public_path__ + "static/media/slide_option_three.560ac2c1.jpg";